/* ============================================================
   NUNU CURVES — SHARED BEHAVIOUR
   Vanilla only. Every block is independent and no-ops if its
   markup isn't present, so one file serves every template.

   The motion layer auto-enhances existing markup (wrapping
   headings, tagging media, indexing grids) so the HTML stays
   clean and ports to Liquid without carrying animation cruft.
   ============================================================ */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $  = function (s, c) { return (c || document).querySelector(s); };
  // Prove JS is alive BEFORE any hiding rules apply. Every reveal state
  // in the CSS is scoped to .js-motion, so if this line never runs the
  // content is simply visible instead of stuck invisible.
  if (!REDUCED) document.documentElement.classList.add('js-motion');


  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------------------------------------------------------
     1. MOBILE NAV
     --------------------------------------------------------- */
  var burger = $('#burger');
  var drawer = $('#drawer');
  if (burger && drawer) {
    var setNav = function (open) {
      document.body.classList.toggle('nav-open', open);
      burger.setAttribute('aria-expanded', open);
      drawer.setAttribute('aria-hidden', !open);
      document.body.style.overflow = open ? 'hidden' : '';
    };
    burger.addEventListener('click', function () {
      setNav(!document.body.classList.contains('nav-open'));
    });
    drawer.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.dnav__toggle')) return;
      if (e.target.closest ? e.target.closest('a') : e.target.tagName === 'A') setNav(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.body.classList.contains('nav-open')) setNav(false);
    });

    // Nested category accordions inside the drawer. Each toggle owns the
    // .dnav__item it sits in, so this works at any depth.
    $$('.dnav__toggle', drawer).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.dnav__item');
        if (!item) return;
        var open = !item.classList.contains('is-open');
        item.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', String(open));
      });
    });
  }

  /* ---------------------------------------------------------
     1b. DESKTOP MEGA MENU
     Hover is handled in CSS. This adds click and keyboard so the
     menu is reachable without a pointer.
     --------------------------------------------------------- */
  var megaItems = $$('.has-mega');
  if (megaItems.length) {
    var closeAllMega = function (except) {
      megaItems.forEach(function (li) {
        if (li === except) return;
        li.classList.remove('is-open');
        var b = $('.nav__top', li);
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    };

    megaItems.forEach(function (li) {
      var btn = $('.nav__top', li);
      if (!btn) return;

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = !li.classList.contains('is-open');
        closeAllMega(li);
        li.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', String(open));
      });

      // Tabbing out of the panel closes it. Deferred so focus has
      // actually landed on the next element before we test it.
      li.addEventListener('focusout', function () {
        setTimeout(function () {
          if (!li.contains(document.activeElement)) {
            li.classList.remove('is-open');
            btn.setAttribute('aria-expanded', 'false');
          }
        }, 0);
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('.has-mega')) closeAllMega(null);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllMega(null);
    });
  }

  /* ---------------------------------------------------------
     2. HEADER STATE + SCROLL PROGRESS
     --------------------------------------------------------- */
  var header = $('#header');
  var bar = null;

  if (!REDUCED) {
    bar = document.createElement('div');
    bar.className = 'progress';
    document.body.appendChild(bar);
  }

  var ticking = false;
  var onScroll = function () {
    // The bar is opaque black on every page now, so `is-solid` no longer
    // switches a background on — it just compacts the bar and shrinks the
    // logo. That should happen on all templates, not only the homepage.
    if (header) {
      header.classList.toggle('is-solid', window.scrollY > 40);
    }
    if (bar) {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.transform = 'scaleX(' + (max > 0 ? window.scrollY / max : 0) + ')';
    }
    ticking = false;
  };
  addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(onScroll); }
  }, { passive: true });
  onScroll();

  /* ---------------------------------------------------------
     3. MOTION SETUP — runs before observers so nothing flashes
     --------------------------------------------------------- */
  if (!REDUCED) {
    // masked line reveal on section + page headings (not the hero h1,
    // which already has its own entrance)
    $$('.section-head h2, .page-head h1, .founder__body .pullquote').forEach(function (el) {
      var inner = document.createElement('span');
      inner.className = 'm-line__in';
      inner.innerHTML = el.innerHTML;
      var line = document.createElement('span');
      line.className = 'm-line';
      line.appendChild(inner);
      el.innerHTML = '';
      el.appendChild(line);
    });

    // film-style unmask on editorial media
    $$('.stage__media, .packages__media, .founder__media, .gallery__main').forEach(function (el) {
      el.classList.add('img-reveal');
    });

    // cascade index for grids
    $$('.grid, .quotes').forEach(function (grid) {
      $$('.reveal', grid).forEach(function (el, i) { el.style.setProperty('--i', i); });
    });
    $$('.ugc').forEach(function (row) {
      $$('a', row).forEach(function (el, i) { el.style.setProperty('--i', i); });
    });

    /* Slide headlines, word by word.
       Walks the node tree rather than reading textContent, so inline
       elements survive — the <em> carrying the gold brand name would
       otherwise be flattened away by the split. */
    $$('.hero h1, .slide__copy h2').forEach(function (heading) {
      var wi = 0;
      var walk = function (node, target) {
        Array.prototype.slice.call(node.childNodes).forEach(function (child) {
          if (child.nodeType === 3) {
            child.textContent.split(/(\s+)/).forEach(function (part) {
              if (!part) return;
              if (/^\s+$/.test(part)) { target.appendChild(document.createTextNode(' ')); return; }
              var outer = document.createElement('span');
              outer.className = 'w';
              outer.style.setProperty('--wi', wi++);
              var inner = document.createElement('span');
              inner.className = 'w__in';
              inner.textContent = part;
              outer.appendChild(inner);
              target.appendChild(outer);
            });
          } else if (child.nodeType === 1) {
            var clone = child.cloneNode(false);
            target.appendChild(clone);
            walk(child, clone);
          }
        });
      };
      var frag = document.createDocumentFragment();
      walk(heading, frag);
      heading.innerHTML = '';
      heading.appendChild(frag);
      heading.classList.add('is-split');

      // Slide headings are driven by which slide is active. The hero
      // heading has no such trigger, so it runs itself on load — with
      // a failsafe, because a headline must never stay invisible.
      if (!heading.closest('.slide')) {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { heading.classList.add('is-lit'); });
        });
        setTimeout(function () { heading.classList.add('is-lit'); }, 2000);
      }
    });
  }

  /* ---------------------------------------------------------
     3b. PARALLAX
     Only on elements that own no other transform, so nothing
     fights the reveal animations for the same property.
     --------------------------------------------------------- */
  if (!REDUCED) {
    /* Depth comes off the element itself via data-depth, so the hero's
       layers can drift at different rates — that separation is what
       reads as depth, rather than any shadow. Negative values move
       against the scroll. Elements measure their PARENT where they are
       absolutely positioned, since a decorative layer pinned to the
       frame has no meaningful box of its own to measure. */
    var pxEls = $$('[data-depth], .founder-card__media img');
    if (pxEls.length) {
      var pxTick = false;
      var pxRun = function () {
        var vh = window.innerHeight;
        pxEls.forEach(function (el) {
          var depth = parseFloat(el.getAttribute('data-depth'));
          if (isNaN(depth)) depth = 22;
          var box = el.offsetParent || el.parentNode;
          var r = (box && box.getBoundingClientRect) ? box.getBoundingClientRect() : el.getBoundingClientRect();
          if (r.bottom < -200 || r.top > vh + 200) return;
          // -1 above the fold, +1 below it
          var progress = ((r.top + r.height / 2) - vh / 2) / vh;
          el.style.setProperty('--py', (progress * depth).toFixed(2) + 'px');
        });
        pxTick = false;
      };
      window.addEventListener('scroll', function () {
        if (pxTick) return;
        pxTick = true;
        requestAnimationFrame(pxRun);
      }, { passive: true });
      window.addEventListener('resize', pxRun, { passive: true });
      pxRun();
    }
  }

  /* ---------------------------------------------------------
     3c. HERO SLIDESHOW
     Crossfade only — no transforms on the slide itself, so it
     never fights the Ken Burns push on the photograph.
     Slide 1 carries .is-active in the markup so the hero is
     never blank without JS.
     --------------------------------------------------------- */
  var stage = $('[data-slideshow]');
  if (stage) {
    var slides = $$('.slide', stage);
    var dots = $$('[data-slide-to]', stage);
    var timerEl = $('.hero__timer', stage);
    var DUR = 7000;
    var cur = 0;
    var tid = null;
    var paused = false;

    stage.style.setProperty('--slide-dur', (DUR / 1000) + 's');

    var runTimer = function (on) {
      if (!timerEl) return;
      timerEl.classList.remove('is-running');
      void timerEl.offsetWidth;               // force reflow to restart it
      if (on && !REDUCED && slides.length > 1) timerEl.classList.add('is-running');
    };

    var schedule = function () {
      clearTimeout(tid);
      if (REDUCED || paused || slides.length < 2) return;
      tid = setTimeout(function () { go(cur + 1); }, DUR);
    };

    var go = function (n) {
      n = (n % slides.length + slides.length) % slides.length;
      slides.forEach(function (s, i) {
        var on = i === n;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', String(!on));
      });
      dots.forEach(function (d, i) {
        d.setAttribute('aria-selected', String(i === n));
      });
      cur = n;
      runTimer(true);
      schedule();
    };

    var pause = function () {
      paused = true;
      clearTimeout(tid);
      if (timerEl) timerEl.classList.remove('is-running');
    };
    var resume = function () {
      if (!paused) return;
      paused = false;
      runTimer(true);
      schedule();
    };

    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { go(i); });
    });
    var prev = $('[data-slide-prev]', stage);
    var next = $('[data-slide-next]', stage);
    if (prev) prev.addEventListener('click', function () { go(cur - 1); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });

    stage.addEventListener('mouseenter', pause);
    stage.addEventListener('mouseleave', resume);
    stage.addEventListener('focusin', pause);
    stage.addEventListener('focusout', function () {
      if (!stage.contains(document.activeElement)) resume();
    });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { pause(); } else { resume(); }
    });

    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
    });

    // swipe
    var sx = null, sy = null;
    stage.addEventListener('touchstart', function (e) {
      sx = e.touches[0].clientX; sy = e.touches[0].clientY;
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      var dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) go(cur + (dx < 0 ? 1 : -1));
      sx = null; sy = null;
    }, { passive: true });

    // Slide 1 is already active in the markup, so its copy would simply
    // be in its final state with nothing to transition from. Drop the
    // class, force a reflow, put it back — now the entrance actually runs.
    slides.forEach(function (s, i) { s.setAttribute('aria-hidden', String(i !== 0)); });
    slides[0].classList.remove('is-active');
    void slides[0].offsetWidth;
    go(0);
  }

  /* ---------------------------------------------------------
     4. SCROLL REVEALS
     --------------------------------------------------------- */
  var revealTargets = $$('.reveal')
    .concat($$('.page-head h1, .section-head h2'))
    .concat($$('.img-reveal'))
    .concat($$('.ugc a'))
    .concat($$('.stages__grid'))
    .concat($$('.trust, .quote, .marquee'));

  if (REDUCED || !('IntersectionObserver' in window)) {
    revealTargets.forEach(function (el) {
      el.classList.add('is-in');
      if (el.classList.contains('stages__grid')) el.classList.add('is-drawn');
    });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        if (entry.target.classList.contains('stages__grid')) {
          entry.target.classList.add('is-drawn');
        }
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    revealTargets.forEach(function (el) { io.observe(el); });

    // Failsafe: if anything is still hidden after 2.5s — observer missed
    // it, element was off-screen in a container that never scrolled, an
    // image decoded late — force it visible. Content must never be
    // permanently invisible because an animation didn't fire.
    setTimeout(function () {
      revealTargets.forEach(function (el) {
        if (!el.classList.contains('is-in')) {
          el.classList.add('is-in');
          if (el.classList.contains('stages__grid')) el.classList.add('is-drawn');
        }
      });
    }, 2500);
  }

  /* ---------------------------------------------------------
     5. PRODUCT GALLERY
     --------------------------------------------------------- */
  var gallery = $('[data-gallery]');
  if (gallery) {
    var main = $('[data-gallery-main]', gallery);
    var frame = main ? main.closest('.gallery__main') : null;
    $$('[data-gallery-thumb]', gallery).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.getAttribute('aria-current') === 'true') return;
        $$('[data-gallery-thumb]', gallery).forEach(function (b) {
          b.setAttribute('aria-current', 'false');
        });
        btn.setAttribute('aria-current', 'true');

        var swap = function () {
          main.src = btn.dataset.full;
          main.alt = $('img', btn).alt;
        };
        if (REDUCED || !frame) { swap(); return; }
        // cross-dissolve rather than a hard swap
        main.style.transition = 'opacity .22s ease';
        main.style.opacity = '0';
        setTimeout(function () {
          swap();
          main.style.opacity = '1';
        }, 220);
      });
    });
  }

  /* ---------------------------------------------------------
     6. VARIANT PILLS — wired to the real variant selector.

     These used to be decorative: clicking "Large" changed a label but
     not the submitted variant, so a customer could be sold the wrong
     size. They now resolve the chosen options to an actual variant,
     set the <select> that the form submits, and reflect price and
     availability. The select stays the source of truth so the form
     still works with JS disabled.
     --------------------------------------------------------- */
  (function () {
    var groups = $$('[data-pills]');
    if (!groups.length) return;

    var select = $('#VariantSelect');
    var priceEl = $('.pdp__price');
    var addBtn = $('#AddToCart');
    var stockEl = $('.stock');
    var barPrice = $('.buybar__price');

    var variants = null;
    var raw = $('[data-variants]');
    if (raw) {
      try { variants = JSON.parse(raw.textContent); } catch (e) { variants = null; }
    }

    /* Show the chosen variant's photo.

       The client's complaint: pick a colour, and the picture stayed on
       whatever was showing. Price and availability updated, the image
       did not — which reads as the click having done nothing.

       Variants without a photo of their own leave the gallery alone;
       blanking it would be worse than showing the previous frame. The
       matching thumbnail is marked current so the strip agrees with
       the main image. */
    var pdpGallery = $('[data-gallery]');
    var pdpMain = pdpGallery ? $('[data-gallery-main]', pdpGallery) : null;

    function showVariantImage(v) {
      if (!pdpMain || !v || !v.image) return;
      if (pdpMain.getAttribute('src') === v.image) return;

      if (v.mid != null) {
        $$('[data-gallery-thumb]', pdpGallery).forEach(function (b) {
          b.setAttribute('aria-current',
            String(b.dataset.mediaId) === String(v.mid) ? 'true' : 'false');
        });
      }

      var swap = function () {
        pdpMain.src = v.image;
        if (v.alt) pdpMain.alt = v.alt;
      };
      if (REDUCED) { swap(); return; }
      pdpMain.style.transition = 'opacity .18s ease';
      pdpMain.style.opacity = '0';
      setTimeout(function () {
        swap();
        pdpMain.style.opacity = '1';
      }, 180);
    }

    function chosen() {
      return groups.map(function (g) {
        var on = g.querySelector('button[aria-pressed="true"]');
        return on ? on.textContent.trim() : null;
      });
    }

    function sync() {
      if (!select || !variants) return;
      var opts = chosen();
      if (opts.indexOf(null) !== -1) return;      // an option not chosen yet

      var match = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) {
          if ((v.options[j] || '') !== opts[j]) { ok = false; break; }
        }
        if (ok) { match = v; break; }
      }
      if (!match) return;

      select.value = match.id;
      select.dispatchEvent(new Event('change', { bubbles: true }));

      if (priceEl) priceEl.textContent = match.price;
      if (barPrice) barPrice.textContent = match.price;

      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? 'Add to Cart' : 'Sold Out';
        addBtn.style.opacity = match.available ? '' : '.4';
      }
      if (stockEl) {
        stockEl.textContent = match.available
          ? 'In stock — ships in 2–4 business days'
          : 'This combination is unavailable';
      }

      showVariantImage(match);
    }

    groups.forEach(function (group) {
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('button');
        if (!btn) return;
        $$('button', group).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        var out = $(group.dataset.pills);
        if (out) out.textContent = btn.textContent.trim();
        sync();
      });
    });

    // keep pills honest if the fallback select is changed directly
    if (select) {
      select.addEventListener('change', function () {
        if (!variants) return;
        var v = variants.filter(function (x) { return String(x.id) === select.value; })[0];
        if (!v) return;
        groups.forEach(function (g) {
          var idx = parseInt(g.dataset.optionIndex, 10);
          $$('button', g).forEach(function (b) {
            b.setAttribute('aria-pressed', b.textContent.trim() === v.options[idx] ? 'true' : 'false');
          });
          var out = $(g.dataset.pills);
          if (out) out.textContent = v.options[idx];
        });
        // the dropdown is a real way to choose, not just a fallback —
        // it has to move the photo too
        showVariantImage(v);
      });
    }
  })();

  /* ---------------------------------------------------------
     7. QUANTITY STEPPERS
     --------------------------------------------------------- */
  $$('[data-qty]').forEach(function (wrap) {
    var input = $('input', wrap);
    wrap.addEventListener('click', function (e) {
      var btn = e.target.closest('button');
      if (!btn) return;
      var v = parseInt(input.value, 10) || 1;
      v += btn.dataset.step === 'up' ? 1 : -1;
      input.value = Math.max(1, v);
    });
  });

  /* ---------------------------------------------------------
     8. ACCORDIONS
     --------------------------------------------------------- */
  $$('.acc__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      btn.setAttribute('aria-expanded', !open);
      if (!panel) return;
      if (open) panel.removeAttribute('data-open');
      else panel.setAttribute('data-open', '');
    });
  });

  /* ---------------------------------------------------------
     9. MOBILE STICKY BUY BAR
     Shows only once the real Add to Cart button has scrolled out of
     view, and delegates to it so there's a single source of truth.
     --------------------------------------------------------- */
  var buybar = $('#BuyBar');
  var realAdd = $('#AddToCart');
  if (buybar && realAdd) {
    $('[data-buybar-add]', buybar).addEventListener('click', function () {
      realAdd.click();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var show = !e.isIntersecting && e.boundingClientRect.top < 0;
          buybar.classList.toggle('is-up', show);
          buybar.setAttribute('aria-hidden', !show);
        });
      }, { threshold: 0 }).observe(realAdd);
    }
  }

  /* ---------------------------------------------------------
     10. PAGE TRANSITIONS
     Fades out before navigating so clicking between pages reads
     as one continuous site rather than a browser page load.
     --------------------------------------------------------- */
  if (!REDUCED) {
    var veil = document.createElement('div');
    veil.className = 'veil';
    document.body.appendChild(veil);

    document.body.classList.add('is-entering');
    setTimeout(function () { document.body.classList.remove('is-entering'); }, 600);

    document.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (!a) return;
      var href = a.getAttribute('href');
      if (!href || a.target === '_blank' || e.metaKey || e.ctrlKey || e.shiftKey) return;
      if (!/\.html($|[?#])/.test(href)) return;
      if (href.split('#')[0] === location.pathname.split('/').pop()) return;

      e.preventDefault();
      document.body.classList.add('is-leaving');
      setTimeout(function () { location.href = href; }, 320);
    });

    // restore on back/forward out of the bfcache
    addEventListener('pageshow', function (e) {
      if (e.persisted) document.body.classList.remove('is-leaving');
    });
  }
})();
